export const NumberFormat = number => Number(number)?.toLocaleString()